const dict = {
  chooseLang: "Choose language",

  //Licence
  instructions: "Instructions",
  step1: "Step 1: Scan the QR Code",
  locateqr: "Locate the QR code on your right.",
  useSmartphone:
    "Use your smartphone's camera or a QR code scanner app to scan it. This will take you to the next step.",
  step2: "Step 2: Enter Playlist Information",
  afterScan:
    "After scanning the QR code, you'll be prompted to enter your playlist information.",
  makeSure: "Make sure to fill in all the required fields.",
  step3: "Step 3: Return to the App",
  onceYou:
    "Once you've entered your playlist details, you can go back to the app and continue your experience.",
  refresh: "REFRESH",
  playlist: "Playlist",
  bigPlaylist: "PLAYLISTS",
  noLicence: "You don't have a Licence.",
  scanLicence: "Scan to buy licence.",
  noPlaylist: "You don't have any playlist",
  privacyBig: "PRIVACY MODE",
  scanToAddBig: "SCAN TO ADD PLAYLIST",
  scanToBuyBig: "SCAN TO BUY LICENCE",
  orVisit: "or visit",
  andenterdeviceID: "and enter this device id:",
  removePlaylist: "Remove Playlist",
  wantToRemove: "Do you want to remove ?",
  cancelBig: "CANCEL",
  //Home
  bigLiveTv: "Live TV's",
  bigMovies: "Movies",
  bigSeries: "Series",
  //Channel-Menu
  noChannels: "This playlist has no channel data",
  searchChannels: "Search Channel",
  tapToPlay: "Tap to play the video stream.",
  categoryEmpty: "This category is empty",
  //Movies
  noMovies: "This playlist has no Movies data",
  searchMovies: "Search Movies",
  //series
  noSeries: "This playlist has no series data",
  searchSeries: "Search Series",
  //entity
  play: "PLAY",
  recommendations: "Recommendations",
  //User Info
  userInfo: "User Info",
  aboutApp: "About App",
  //Userinfo
  account: "Account",
  subscriptions: "Subscriptions",
  privacyPilicy: "Privacy & Policy",
  languge: "Languge",
  english: "English",
  italian: "Italian",
  german: "German",
  spanish: "Spanish",
  french: "French",
  greek: "Greek",
  //lastones
  playInfo: "Playlist Info",
  playName: "Playlist Name:",
  host: "Host:",
  username: "Username:",
  password: "Password:",
  packName: "Package Name:",
  expireDate: "Expire Date:",
  //privacyPolicy

  one: "1. Content Disclaimer: Innplay is a platform designed to enhance your digital experience. However, it is important to note that Innplay does not host, provide, or distribute video content. Our service is structured to support your digital journey, but we do not bear responsibility for the availability, quality, or content of video material, as this is outside the scope of our services.",
  two: "2. No Liability for Third-Party Content: Innplay LLC is not liable for any third-party content you may access through our application. Your engagement with any external content, including its legality, reliability, or appropriateness, is solely at your own risk.",
  three:
    "3. Jurisdiction and Compliance: Innplay LLC operates under the jurisdiction of the United States. Users are responsible for ensuring their use of the application is in compliance with all local, state, and federal laws.",
  four: "4. Pricing Policy: Prices for Innplay services are subject to change at any time without prior notice. By accepting this agreement, you acknowledge and agree that pricing may vary and that any such changes will not affect your current service until the renewal of your subscription.",
  five: `5. No Warranty: The Innplay application and its services are provided "as is" without any express or implied warranties, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, and non-infringement.`,
  six: "6. Acceptance of Terms: By clicking Agree, you agree to be bound by the terms of this disclaimer and acknowledge that any violation may result in termination of your access to Innplay services.",
  orbixUserAgreement: "INNPLAY USER AGREEMENT AND DISCLAIMER",
  beforeyouProcc:
    "Before you proceed, please read and accept the following terms and conditions:",

  //Evomedia privacy policy
  evomediaTitle: "Evo TV Privacy Policy",
  evomediaSubtitle:
    "Please read the following information about how your data is handled:",
  evomediaSection1Title: "1. Technical Data Processing and Collection",
  evomediaSection1Body1:
    "The evo tv application is designed exclusively as a technical utility for eligible Evomedia customers. The application does not feature manual registration forms, in-app account creation, or collect direct personal details (such as your name, phone number, or email address).",
  evomediaSection1Body2:
    "However, to enable media streaming and ensure service security, the system processes the following category of data:",
  evomediaSection1Body3:
    "Device Identifiers: The device's MAC address or an internal client ID is transmitted securely (via SSL/HTTPS) to our servers for the sole purpose of validating, authenticating, and authorizing access to the multimedia streaming feeds linked to your contracted plan.",
  evomediaSection1Body4:
    "Legal Basis and Purpose: Processing these identifiers is strictly necessary for the performance of a contract (delivering the requested streaming service) and for security and fraud prevention (ensuring only authorized devices access the protected feeds). This technical data is never used for marketing purposes, is never shared with third parties, and is not used to track your broader browsing history.",
  evomediaSection2Title: "2. User Rights (GDPR)",
  evomediaSection2Body1:
    "Under the General Data Protection Regulation (GDPR), since technical identifiers are linked to your underlying customer account, you retain the right to access, rectify, restrict, or request the deletion of data associated with your device. To exercise these rights, please contact us at suporte@evomedia.pt.",
  evomediaSection3Title: "3. Children's Privacy",
  evomediaSection3Body1:
    "We do not directly market services to children, nor do we knowingly collect data from minors under the age of 13. App access is managed and authorized through the account holder (the adult client).",
  evomediaSection4Title: "4. Changes to This Policy",
  evomediaSection4Body1:
    "We may update our Privacy Policy from time to time to reflect technical upgrades or regulatory changes. Any updates will become effective immediately upon being posted directly to this page.",
  evomediaSection5Title: "5. Contact Us",
  evomediaSection5Body1:
    "If you have any questions regarding your privacy or the technical management of the application, please contact us via:",
  evomediaSection5Body2: "Official Support Email: suporte@evomedia.pt",
  evomediaSection5Body3: "Developer Account Email: evomediamobile@gmail.com",

  //additional
  exitApp: "Exit Innplay",
  wantToExit: "Are you sure you want to exit Innplay?",
  Resume: "Resume",

  whatsnewinv: "What's New in v",
  whatsnew: "What's New",

  instanthomescreen: "Enhanced Channel Menu Navigation",
  instanthomescreendesc:
    "Improved navigation flow and user experience in channel selection.",
  turbomoviesearch: "Comprehensive Settings Information",
  turbomoviesearchdesc:
    "More detailed settings and configuration options gathered in one place.",
  lighterondataandbattery: "Smart Resume Function",
  lighterondataandbatterydesc:
    "Automatically saves and restores your viewing position seamlessly.",
  underthehoodfixes: "Under-the-Hood Fixes",
  underthehoodfixesdesc:
    "Enhanced player stability and seek operation reliability.",
};

export default dict;
